import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import useCustomer from "common/datahooks/useCustomer";

type CouponState = {
  couponCode: string;
  isCouponApplied: boolean;
  couponError?: string;
};

export default function useExternalCouponState() {
  const { customerInfo } = useCustomer();
  const [searchParams, setSearchParams] = useSearchParams();

  const localStorageKey = customerInfo
    ? `${customerInfo.id}:couponState`
    : undefined;

  const couponCodeSearchParam = searchParams.get("coupon");
  const isCouponApplied = searchParams.get("coupon_applied");
  const couponError = searchParams.get("coupon_error");

  let couponState: CouponState;

  const sessionStorageCouponState = sessionStorage.getItem(localStorageKey);
  if (sessionStorageCouponState) {
    try {
      couponState = JSON.parse(sessionStorageCouponState);
    } catch {
      console.error("Error parsing coupon state");
    }
  } else if (couponCodeSearchParam) {
    couponState = {
      couponCode: couponCodeSearchParam,
      isCouponApplied: isCouponApplied ? Boolean(isCouponApplied) : false,
      couponError,
    };
  }

  useEffect(() => {
    if (localStorageKey && couponCodeSearchParam) {
      sessionStorage.setItem(
        localStorageKey,
        JSON.stringify({
          couponCode: couponCodeSearchParam,
          isCouponApplied: isCouponApplied ? Boolean(isCouponApplied) : false,
          couponError,
        }),
      );

      searchParams.delete("coupon");
      searchParams.delete("coupon_applied");
      searchParams.delete("coupon_error");
      setSearchParams(searchParams);
    }
  }, [localStorageKey]);

  function clearCoupon() {
    sessionStorage.removeItem(localStorageKey);
  }

  return {
    couponState,
    clearCoupon,
  };
}
